// removed by extract-text-webpack-plugin
module.exports = {"root":"SignupForm__root__1iQOT","name":"SignupForm__name__3rw_L","isPoolOwner":"SignupForm__isPoolOwner__2qG3y","hasAcceptedNewsletter":"SignupForm__hasAcceptedNewsletter__38w2o","hasAcceptedNewsletterText":"SignupForm__hasAcceptedNewsletterText__3Fjrs","inputText":"SignupForm__inputText__wkWp_","bottomWrapper":"SignupForm__bottomWrapper__1uJjE","termsText":"SignupForm__termsText__rmQN2","termsLink":"SignupForm__termsLink__2Ildv","loginLink":"SignupForm__loginLink__3rLRr","loginLinkInfo":"SignupForm__loginLinkInfo__2tofk"};


//////////////////
// WEBPACK FOOTER
// ./src/forms/SignupForm/SignupForm.css
// module id = 1739
// module chunks = 0